import { render, staticRenderFns } from "./dialogueM4.vue?vue&type=template&id=19e7b4c8&"
import script from "./dialogueM4.vue?vue&type=script&lang=js&"
export * from "./dialogueM4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports